import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import { responsiveWrapper } from 'react-responsive-redux';
import { BreakpointProvider } from 'hedron';
import ReactGA from 'react-ga';
import AppMobile from '../components_mobile/App/App';
import AppDesktop from '../components_desktop/AppDesktop';
import TrackingScripts from '../components_common/TrackingScripts';
import FullHeightFlex from '../components_common/FullHeightFlex';
import centeredFlexColumnStyle from './centeredFlexColumnStyle';
import { requiresCookieBanner, setClientIdCookieIfEmpty } from '../helpers/helpers';
import trackVisit from '../helpers/trackItalHelper';
import { initTracking, ReactPixel } from '../helpers';
import { sendFdTrackingEvent } from '../helpers/fdHelper';
import ModalAutoDisplayer from '../components/ModalAutoDisplayer';
import HeadWrapper from '../components_mobile/components/HeadWrapper';

const Desktop = responsiveWrapper({ minWidth: 1024 });
const Mobile = responsiveWrapper({ maxWidth: 1023 });

const mapStateToProps = ({
  api: {
    scripts: { riskifiedDomain, riskifiedSessionId },
    countryId,
    basePathAccount,
    basePathAdmin,
    basePathSecure,
    basePathWeb,
    email,
    fbOptions,
    euCookiePolicyAccepted,
    isEu,
    product,
    userId,
  },
  responsive,
}) => ({
  riskifiedDomain,
  riskifiedSessionId,
  responsive,
  countryId,
  basePathAccount,
  basePathAdmin,
  basePathSecure,
  basePathWeb,
  email,
  fbOptions,
  euCookiePolicyAccepted,
  isEu,
  product,
  userId,
});

class AppWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = { init: true };
  }

  componentWillMount() {
    const {
      responsive: { desktop, phone },
    } = this.props;

    const { publicRuntimeConfig } = getConfig();
    initTracking(publicRuntimeConfig.mixpanelKey);

    const mobile = phone;
    if (typeof window === 'undefined') {
      this.setState({ desktop, mobile });
    }
  }

  componentDidMount() {
    Modal.setAppElement('#root');
    this.setState({ desktop: window.innerWidth > 1023, init: false });

    const { basePathAccount, basePathAdmin, basePathSecure, basePathWeb } = this.props;

    const { publicRuntimeConfig } = getConfig();

    if (publicRuntimeConfig.trackitalFeatureFlag.toLowerCase() === 'true') {
      setClientIdCookieIfEmpty(basePathWeb);
      trackVisit(basePathWeb, basePathAdmin, basePathSecure, basePathAccount);
    }

    const { email, fbOptions, userId } = this.props;
    ReactGA.initialize('UA-11398566-5', { debug: false });
    ReactGA.set({ '&uid': userId });
    ReactGA.pageview(window.location.pathname);
    const { debug } = fbOptions;
    ReactPixel.init({ em: email }, debug);

    sendFdTrackingEvent();
  }

  renderDesktop(desktopComp) {
    const { metadata, currPage } = this.props;

    return (
      <Desktop style={centeredFlexColumnStyle}>
        <AppDesktop style={centeredFlexColumnStyle} metadata={metadata} currPage={currPage}>
          {desktopComp}
        </AppDesktop>
      </Desktop>
    );
  }

  renderMobile(mobileComp) {
    const { metadata, currPage } = this.props;

    return (
      <Mobile>
        <AppMobile metadata={metadata} currPage={currPage}>
          {mobileComp}
        </AppMobile>
      </Mobile>
    );
  }

  renderTrackingScripts = () => {
    const { countryId, isEu, euCookiePolicyAccepted, riskifiedDomain, riskifiedSessionId, product } = this.props;

    return (
      <TrackingScripts
        countryId={countryId}
        riskifiedDomain={riskifiedDomain}
        riskifiedSessionId={riskifiedSessionId}
        runAdroll={!requiresCookieBanner(isEu, euCookiePolicyAccepted)}
        adrollCustomData={product ? product.adroll_custom_data : null}
        googleProduct={product}
      />
    );
  };

  renderApp() {
    const { desktopComp, mobileComp } = this.props;
    const { mobile, init } = this.state;

    if (!init) {
      return (
        <FullHeightFlex id="root">
          {this.renderDesktop(desktopComp)}
          {this.renderMobile(mobileComp)}
          <ModalAutoDisplayer />
        </FullHeightFlex>
      );
    }

    if (mobile) {
      return <FullHeightFlex id="root">{this.renderMobile(mobileComp)}</FullHeightFlex>;
    }

    return <FullHeightFlex id="root">{this.renderDesktop(desktopComp)}</FullHeightFlex>;
  }

  render() {
    const {
      serverRuntimeConfig: { isServer },
    } = getConfig();
    return (
      <BreakpointProvider breakpoints={{ lg: 1024 }}>
        <>
          {isServer && <HeadWrapper {...this.props} />}
          {this.renderApp()}
          {this.renderTrackingScripts()}
        </>
      </BreakpointProvider>
    );
  }
}

AppWrapper.propTypes = {
  basePathWeb: PropTypes.string.isRequired,
  basePathAdmin: PropTypes.string.isRequired,
  basePathSecure: PropTypes.string.isRequired,
  basePathAccount: PropTypes.string.isRequired,
  currPage: PropTypes.string,
  desktopComp: PropTypes.element.isRequired,
  mobileComp: PropTypes.element.isRequired,
  riskifiedDomain: PropTypes.string,
  riskifiedSessionId: PropTypes.string,
  metadata: PropTypes.shape({
    title: PropTypes.func,
    description: PropTypes.func,
  }),
  euCookiePolicyAccepted: PropTypes.bool,
  isEu: PropTypes.bool,
};

export default connect(mapStateToProps)(AppWrapper);
